import { Navigate, useParams } from 'react-router';

import { NAV_HELPERS } from '@assets/helpers/utils/navigation.ts';

/** Keeps existing setup links usable after moving configuration into the course modal. */
export const DrivingRangeSetupRedirect = () => {
  const { courseId } = useParams();
  return <Navigate to={NAV_HELPERS.courseDrivingRange(courseId)} replace />;
};
